export class HeaderEntry {
  constructor(_targetElem, _motionElems) {
    this.scrollTop = document.documentElement.scrollTop;
    this.headerHideFlag = false;
    this.headerMenuTimeout;
    this.headerMenuElem = document.querySelector("#js-header-entry");
    this.excute();
  }

  excute = () => {
    const _this = this;

    const mouseenterFunc = (e) => {
      e.preventDefault();
      _this.headerMenuElem.classList.remove("is-entry-active");
      _this.headerMenuElem.classList.remove("is-entry-hide");
      _this.headerMenuElem.classList.add("is-entry-active");
      clearTimeout(_this.headerMenuTimeout);
    };
    const mouseleaveFunc = (e) => {
      e.preventDefault();
      _this.headerMenuElem.classList.add("is-entry-hide");
      _this.headerMenuTimeout = setTimeout(function () {
        _this.headerMenuElem.classList.remove("is-entry-active");
        _this.headerMenuElem.classList.remove("is-entry-hide");
      }, 300);
    };

    this.headerMenuElem.addEventListener("mouseenter", mouseenterFunc);
    this.headerMenuElem.addEventListener("mouseleave", mouseleaveFunc);

    // this.headerMenuElem.addEventListener("click", function (e) {
    //   e.preventDefault();
    //   if (!_this.headerMenuElem.classList.contains("is-entry-active")) {
    //     // if (document.body.classList.contains('is-entry-hide')) _this.headerHideFlag = true;
    //     _this.headerMenuElem.classList.add("is-entry-active");
    //     if (document.body.classList.contains("is-active-menu")) {
    //       _this.headerMenuElem.classList.add("is-entry-active-menu");
    //     }
    //   } else {
    //     _this.headerMenuElem.classList.add("is-entry-hide");
    //     _this.headerMenuTimeout = setTimeout(function () {
    //       // htmlElem.classList.remove('is-active-menu')
    //       _this.headerMenuElem.classList.remove("is-entry-active");
    //       _this.headerMenuElem.classList.remove("is-entry-hide");
    //       _this.headerMenuElem.classList.remove("is-entry-active-menu");
    //       // setTimeout(function () {
    //       // if(_this.headerHideFlag) document.body.classList.add('is-entry-hide')
    //       // }, 10)
    //     }, 300); //500
    //   }
    // });
  };
}
